<template>
    <div>
        <div class="bd_wrapper hidden-xs-only">
            <div class="bd_box common_width">
                <div class="clearfix">
                    <common-title
                        :titleText="businessDevelopmentText"
                    ></common-title>
                </div>
                <div class="img_all">
                    <ul class="imgs_ul clearfix">
                        <li
                            v-for="(item, idx) in imgList"
                            :key="item.id"
                            :class="{ nomr: idx == 1 || idx == 3 }"
                            @click="jumpDetail(item)"
                        >
                            <img :src="item.imageUrl" alt="" />
                            <div class="mask"></div>
                            <div class="text clearfix">
                                <div class="line_all fl clearfix">
                                    <div class="short_line fl"></div>
                                    <div class="lone_line fl"></div>
                                </div>
                                <span
                                    class="fl title"
                                    v-text="item.title"
                                ></span>
                                <div class="line_all fl clearfix">
                                    <div class="lone_line fl"></div>
                                    <div class="short_line fl"></div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="bd_phone_wrapper hidden-sm-and-up">
            <div class="top clearfix">
                <phone-title :phoneTitleObj="businessDevelopmentTextPe"></phone-title>
            </div>
            <div class="bottom">
                <ul class="phone_ul clearfix">
                    <li v-for="(item, idx) in imgList" :key="idx" @click="jumpDetail(item)">
                        <img :src="item.imageUrl" alt="" />
                        <div class="mask"></div>
                        <div class="text">
                            <span class="el-icon-setting"></span>
                            <span v-text="item.title"></span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import CommonTitle from "@/components/title";
import PhoneTitle from "@/components/phonetitle";
import { expandIe } from "../../../api/expand/expand";
export default {
    components: {
        CommonTitle,
        PhoneTitle,
    },

    methods: {
        getExpandRt() {
            expandIe().then((res) => {
                console.log(res);
                this.imgList = res.rows;
            });
        },
        jumpDetail(item) {
          this.$router.push({
            path: 'detail',
            query: {
              detailObj: item,
            }
          })
        }
    },
    mounted() {
        this.getExpandRt();
    },
    data() {
        return {
            businessDevelopmentText: "经营发展",
            businessDevelopmentTextPe: {
              title: '经营发展'
            },
            imgList: [
                {
                    id: 1,
                    imgUrl: require("../../../assets/img/jy_a.png"),
                    text: "医药产业",
                },
                {
                    id: 2,
                    imgUrl: require("../../../assets/img/jy_b.png"),
                    text: "健康产业",
                },
                {
                    id: 3,
                    imgUrl: require("../../../assets/img/jy_b.png"),
                    text: "养老产业",
                },
                {
                    id: 4,
                    imgUrl: require("../../../assets/img/jy_d.png"),
                    text: "生态产业",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/mixin.scss";
// move
.bd_phone_wrapper {
    width: 100%;
    box-sizing: border-box;
    padding: 0 px2rem(20);
    margin-top: px2rem(20);
    .phone_ul {
        width: 100%;
        margin-top: px2rem(20);
        li {
            position: relative;
            width: 100%;
            height: px2rem(200);
            margin-bottom: px2rem(20);
            border-radius: px2rem(8);
            img {
                width: 100%;
                height: 100%;
            }
            .mask {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: #d3d3d3;
                opacity: 0.1;
            }
            .text {
                position: absolute;
                /* 定位垂直水平居中 */
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: #fff;
                font-size: px2rem(20);
                font-weight: 800;
            }
        }
    }
}
// pc
.bd_wrapper {
    width: 100%;
    height: 742px;
    padding-top: 45px;
    box-sizing: border-box;
    background-color: #f8f8f8;
    .bd_box {
        height: 100%;
        .img_all {
            width: 1119px;
            padding-top: 28px;
            .imgs_ul {
                li {
                    position: relative;
                    float: left;
                    width: 552px;
                    height: 290px;
                    border: 1px solid #eee;
                    margin-right: 10px;
                    border-radius: 8px;
                    margin-bottom: 10px;
                    cursor: pointer;
                    img {
                        position: absolute;
                        top: 0;
                        right: 0;
                        width: 100%;
                        height: 290px;
                    }
                    .mask {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: #d3d3d3;
                        opacity: 0.1;
                    }
                    .text {
                        position: absolute;
                        /* 定位垂直水平居中 */
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        .line_all {
                            position: relative;
                            width: 24px;
                            height: 24px;
                            .short_line {
                                width: 4px;
                                height: 16px;
                                background-color: #fff;
                                border-radius: 8px;
                            }
                            .lone_line {
                                position: absolute;
                                top: -4px;
                                right: 0;
                                left: 12px;
                                width: 4px;
                                height: 24px;
                                background-color: #fff;
                                border-radius: 8px;
                            }
                        }
                        .title {
                            margin: 0 22px;
                            font-size: 18px;
                            color: #fff;
                        }
                    }
                }
                .nomr {
                    margin-right: 0;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Home/components/Businessdevelopment.vue